import {
  PiStorefront,
  PiAddressBook,
  PiNotepad,
  PiHandCoins,
  PiCalendarStar,
  PiHandshake,
} from 'react-icons/pi'
import { useNavigate } from 'react-router-dom'

const actions = [
  { icon: PiHandshake, label: 'Deal', href: '/deals/create' },
  { icon: PiStorefront, label: 'Company', href: '/companies/create' },
  { icon: PiAddressBook, label: 'Contact', href: '/contacts/create' },
  { icon: PiNotepad, label: 'Note', href: '/notes/create' },
  { icon: PiCalendarStar, label: 'Reminder', href: '/reminders/create' },
  { icon: PiHandCoins, label: 'Sample', href: '/samples/create' },
]

export default function MobileDrawer({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {isOpen && (
        <div
          className="fixed inset-0 bg-new-company-overlay z-40 transition-opacity"
          onClick={() => onClose()}
        />
      )}

      <div
        className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-50 transform transition-transform duration-300 ease-out ${
          isOpen ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="p-[24px] text-center">
          <h3 className="text-lg font-semibold text-gray-900">Create a...</h3>
        </div>

        <div className="px-6 pb-8">
          <div className="grid grid-cols-2 gap-3">
            {actions.map((action, index) => (
              <button
                key={index}
                className="bg-new-company-pistachio-3 rounded-xl p-2 flex flex-col items-center justify-center gap-1 hover:opacity-80 transition-opacity shadow-[0px_1px_4px_0px_rgba(12,12,13,1,0.05)]"
                onClick={() => {
                  onClose()
                  if (action.href) {
                    navigate(action.href)
                  }
                }}
              >
                <action.icon className="w-8 h-8 text-gray-700" />
                <span className="text-sm font-medium text-gray-900">
                  {action.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
